module.exports = __webpack_public_path__ + "static/img/Joe_Daniher_mobile.b7ab9df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joe_Daniher_mobile.jpg
// module id = Ucql
// module chunks = 0